import Body from '@oberoninternal/travelbase-ds/components/primitive/Body';
import { Flex } from '@rebass/grid';
import { FormattedMessage } from 'react-intl';
import CheckboxFilter from './CheckboxFilter';
import { FilterCategory } from '../entities/Filter';
import styled from 'styled-components';
import TextButton from '@oberoninternal/travelbase-ds/components/action/TextButton';
import { getAssignmentColor } from '@oberoninternal/travelbase-ds/constants/theme';
import Dots from './svg/Dots';
import useSesame from '@oberoninternal/travelbase-ds/hooks/useSesame';

interface Props {
    category: FilterCategory;
}

const FILTER_SIZE = 4;

const AccommodationTypeFilter = ({ category }: Props) => {
    const { open, onOpen } = useSesame();
    const { filters, handle, formikKey } = category;

    if (!filters?.length) {
        return null;
    }

    return (
        <Flex my={2} flexDirection="column">
            <Body variant="micro" style={{ fontWeight: 'bold', marginBottom: '0.8rem' }}>
                <FormattedMessage defaultMessage="Type accommodatie" />
            </Body>
            {filters.slice(0, open ? undefined : FILTER_SIZE).map(filter => (
                <CheckboxFilter
                    key={filter.handle}
                    id={filter.handle}
                    label={filter.label}
                    fieldName={formikKey ?? handle}
                    fieldValue={filter.handle}
                    hits={filter.hits}
                    my="3"
                />
            ))}
            {!open && filters.length > FILTER_SIZE && (
                <StyledTextButton onClick={onOpen} size="tiny">
                    <DotsIcon />
                    <FormattedMessage
                        defaultMessage="Alle {numberOfFilters} tonen"
                        values={{ numberOfFilters: filters.length }}
                    />
                </StyledTextButton>
            )}
        </Flex>
    );
};

export default AccommodationTypeFilter;

const DotsIcon = styled(Dots)`
    color: inherit;
`;

const StyledTextButton = styled(TextButton)`
    color: ${({ theme }) => theme.colors.neutral['90']};
    span {
        font-weight: 600;

        svg {
            margin-right: 1.2rem;
        }
    }

    &:hover {
        color: ${({ theme }) => getAssignmentColor(theme, theme.colorAssignments.textAction)};
        span:after {
            border: none;
        }
    }

    span {
        font-weight: 600;

        svg {
            margin-right: 1.2rem;
        }
    }
`;
